<div nxLayout="grid maxwidth" *ngIf="activePolicies">
    <div nxRow>
      <div nxCol="12" class="docs-grid-colored-col policies">
        <div class="my-policies">
          <div class="heading">
            <div class="heading-content">
              <h3 nxHeadline="subsection-medium" translate class="title">policy.my-policies</h3>
            </div>
            <div class="heading-tabs">
              <cpc-tab-selector-group>
                <cpc-tab-selector *ngFor="let content of ['active', 'past']; let i = index"
                  [selected]="selectedIndex === i" (click)="tabChanged(i)">
                  {{ 'product-state.'+content | translate }}
                </cpc-tab-selector>
              </cpc-tab-selector-group>
            </div>
          </div>
  
          <div *ngIf="selectedIndex==0">
            <div nxRow class="tab-content">
              <ng-template ngFor let-policy="$implicit" [ngForOf]="activePolicies">
                <div nxCol="12, 12, 12, 12, 6" class="policy-column">
                  <app-policy-b2b-lease-card [policy]="policy" [state]="policyStates.active"></app-policy-b2b-lease-card>
                </div>
              </ng-template>
            </div>
          </div>
          <div *ngIf="selectedIndex==1">
            <div nxRow class="tab-content">
              <ng-template ngFor let-policy="$implicit" [ngForOf]="inactivePolicies">
                <div nxCol="12, 12, 12, 12, 6" class="policy-column">
                  <app-policy-b2b-lease-card [policy]="policy" [state]="policyStates.past"></app-policy-b2b-lease-card>
                </div>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  